__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-apply-supplementary-card-germany'].baseUrl;
import ModuleContainer from './components/AxpApplySupplementaryCardGermany';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      'axp-product-ducks': '^0.3.1',
      'iguazu': '^3.2.0',
      'iguazu-holocron': '^1.3.0',
      'iguazu-rest': '^1.10.2',
      'iguazu-rpc': '^1.6.1'
    }
  });
}